<template>
  <div
    v-if="loading"
    class="my-8 flex justify-center items-center flex-col"
  >
    <p
      v-if="topMessage"
      class="my-4 text-xl text-vp-pink text-primary"
    >
      {{ topMessage }}
    </p>
    <div
      class="my-4 spinner border-vp-pink border-primary rounded-full animate-spin"
      :class="[spinnerClasses[props.size], borderClasses[props.size]]"
    />
    <p
      v-if="bottomMessage"
      class="my-4 text-xl text-vp-pink text-primary"
    >
      {{ bottomMessage }}
    </p>
  </div>
  <div
    v-if="useShow"
    v-show="!loading"
  >
    <slot />
  </div>
  <slot v-if="!loading && !useShow" />
</template>

<script setup lang="ts">
type Size = 'sm' | 'md' | 'lg';

type Props = {
  loading: boolean;
  topMessage?: string;
  bottomMessage?: string;
  size?: Size;
  useShow?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  size: 'lg',
});

const spinnerClasses: Record<Size, string> = {
  sm: 'w-8 h-8',
  md: 'w-16 h-16',
  lg: 'w-32 h-32',
};

const borderClasses: Record<Size, string> = {
  sm: 'border-t-2',
  md: 'border-t-2',
  lg: 'border-t-4',
};
</script>
